
<template>
  <v-layout
    v-show="showWeeklySchedule"
    v-resize="onResize"
    column
    style="padding-top: 56px"
  >
    <v-toolbar
      v-if="partner === 'establishment'"
      color="primary"
      dark
      class="elevation-0"
    >
      <v-toolbar-title>Agenda da Semana</v-toolbar-title>
    </v-toolbar>
    <v-toolbar v-else v-bind:color="color" dark class="elevation-0">
      <v-toolbar-title>Agenda da Semana</v-toolbar-title>
    </v-toolbar>
    <v-data-table
      :items="desserts"
      :hide-headers="isMobile"
      :class="{ mobile: isMobile }"
    >
      <template slot="items" slot-scope="props">
        <!--Days-->
        <tr v-if="!isMobile">
          <th class="text-xs-left">Dia da Semana</th>
          <td
            v-for="(day, index) in weeklySchedule.days"
            :key="`day-${index}`"
            class="text-xs-left"
          >
            <span small class="text-uppercase caption font-weight-regular">
              {{ formated(day) }}
            </span>
            <br />
            <span small class="text-uppercase caption font-weight-regular">
              {{ toWeekday(day) }}
            </span>
          </td>
        </tr>

        <tr v-else>
          <td>
            <ul class="flex-content">
              <li
                v-for="(day, index) in weeklySchedule.days"
                :key="`day-${index}`"
                class="flex-item"
                data-label="Dia da Semana"
              >
                <span small class="text-uppercase caption font-weight-regular">
                  {{ formated(day) }}
                </span>
                <br />
                <span small class="text-uppercase caption font-weight-regular">
                  {{ toWeekday(day) }}
                </span>
              </li>
            </ul>
          </td>
        </tr>

        <!--Cancelled-->
        <tr v-if="!isMobile">
          <th class="text-xs-left">Cancelados</th>
          <td
            v-for="(canceled, index) in weeklySchedule.canceled"
            :key="`canceled-${index}`"
            class="text-xs-left"
          >
            <span small class="text-uppercase caption font-weight-regular">
              {{ $n(canceled, "currency") }}
            </span>
          </td>
        </tr>

        <tr v-else>
          <td>
            <ul class="flex-content">
              <li
                v-for="(canceled, index) in weeklySchedule.canceled"
                :key="`canceled-${index}`"
                class="flex-item"
                data-label="Cancelados"
              >
                <span small class="text-uppercase caption font-weight-regular">
                  {{ $n(canceled, "currency") }}
                </span>
              </li>
            </ul>
          </td>
        </tr>

        <!--Balance-->
        <tr v-if="!isMobile">
          <th class="text-xs-left">Saldo</th>
          <td
            v-for="(valid, index) in weeklySchedule.valids"
            :key="`valid-${index}`"
            class="text-xs-left"
          >
            <span small class="text-uppercase caption font-weight-regular">
              {{ $n(valid, "currency") }}
            </span>
          </td>
        </tr>

        <tr v-else>
          <td>
            <ul class="flex-content">
              <li
                v-for="(valid, index) in weeklySchedule.valids"
                :key="`valid-${index}`"
                class="flex-item"
                data-label="Saldo"
              >
                <span small class="text-uppercase caption font-weight-regular">
                  {{ $n(valid, "currency") }}
                </span>
              </li>
            </ul>
          </td>
        </tr>

        <!--Status-->
        <tr v-if="!isMobile">
          <th class="text-xs-left">Status</th>
          <td
            v-for="(status, index) in weeklySchedule.days"
            :key="`status-${index}`"
            class="text-xs-left"
          >
            <span small class="text-uppercase caption font-weight-regular">
              {{ toStatus(status) }}
            </span>
          </td>
        </tr>

        <tr v-else>
          <td>
            <ul class="flex-content">
              <li
                v-for="(status, index) in weeklySchedule.days"
                :key="`status-${index}`"
                class="flex-item"
                data-label="Status"
              >
                <span small class="text-uppercase caption font-weight-regular">
                  {{ toStatus(status) }}
                </span>
              </li>
            </ul>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  data: () => ({
    isLoading: false,
    isMobile: false,
    desserts: [
      {
        value: false,
        sortable: false,
      },
    ],
    weeknames: [
      "",
      "Segunda",
      "Terça",
      "Quarta",
      "Quinta",
      "Sexta",
      "Sabado",
      "Domingo",
    ],
  }),
  created() {
    this.$store.dispatch("dashboard/getWeeklySchedule");
  },
  computed: {
    ...mapGetters({
      weeklySchedule: "dashboard/weeklySchedule",
      showWeeklySchedule: "dashboard/showWeeklySchedule",
      color: "account/color",
      partner: "account/partner",
    }),
  },
  methods: {
    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
    toWeekday(date) {
      const weekday = moment(date).isoWeekday();
      return this.weeknames[weekday];
    },
    formated(date) {
      return moment(date).format("DD/MM");
    },
    toStatus(date) {
      const today = moment().format("DD/MM/YYYY");
      const statusDate = moment(date).format("DD/MM/YYYY");
      if (today > statusDate) {
        return "depositado";
      }
      return "agendado";
    },
  },
};
</script>
  <style>
.mobile {
  color: #333;
}

@media screen and (max-width: 768px) {
  .mobile table.v-table tr {
    max-width: 100%;
    position: relative;
    display: block;
  }

  .mobile table.v-table tr:nth-child(odd) {
    border-left: 6px solid #b2b2b8;
  }

  .mobile table.v-table tr:nth-child(even) {
    border-left: 6px solid #636366;
  }

  .mobile table.v-table tr td {
    display: flex;
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
    height: auto;
    padding: 10px;
  }

  .mobile table.v-table tr td ul li:before {
    content: attr(data-label);
    padding-right: 0.5em;
    text-align: left;
    display: block;
    color: #999;
  }
  .v-datatable__actions__select {
    width: 50%;
    margin: 0px;
    justify-content: flex-start;
  }
  .mobile .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
    background: transparent;
  }
}
.flex-content {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.flex-item {
  padding: 5px;
  width: 50%;
  height: 40px;
  margin-top: 10px;
}
</style>
